import { render, staticRenderFns } from "./OfferDetails.vue?vue&type=template&id=6644e11f&scoped=true"
import script from "./OfferDetails.vue?vue&type=script&lang=ts"
export * from "./OfferDetails.vue?vue&type=script&lang=ts"
import style0 from "./OfferDetails.vue?vue&type=style&index=0&id=6644e11f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6644e11f",
  null
  
)

export default component.exports